<template>
    <div>
        <figure class="image">
            <img :src="src" :alt="alt" @click="clickImage()">
        </figure>
        <b-modal :active.sync="modalActive">
            <p class="image is-4by3">
                <img :src="src" :alt="alt">
            </p>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: ['src', 'alt'],
        name: "ProgramImage",
        methods: {
            clickImage() {
                this.modalActive = true
            }
        },
        data() {
            return {
                modalActive: false
            }
        }
    }
</script>